import { useState } from "react";
import { Share2, Check } from "lucide-react";

const ShareButton = ({
  className = "",
  label = "Share",
  variant = "ghost",
  testId = "share-button",
  shareText = "Come to RVA Students with me — Saturday, November 7th at 6:30 PM. One City. One Generation. One Mission.",
  shareUrl = process.env.REACT_APP_SHARE_URL || "",
}) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = typeof window !== "undefined" ? window.location.origin : shareUrl;
    const finalUrl = url && url.startsWith("http") ? url : shareUrl;
    const payload = {
      title: "RVA Students",
      text: shareText,
      url: finalUrl,
    };
    try {
      if (typeof navigator !== "undefined" && navigator.share) {
        await navigator.share(payload);
        return;
      }
      if (typeof navigator !== "undefined" && navigator.clipboard) {
        await navigator.clipboard.writeText(`${shareText} ${finalUrl}`);
        setCopied(true);
        setTimeout(() => setCopied(false), 2200);
      }
    } catch (e) {
      // silent — user likely dismissed native share sheet
    }
  };

  const base =
    variant === "primary"
      ? "btn-primary"
      : "btn-ghost";

  return (
    <button
      type="button"
      onClick={handleShare}
      className={`${base} ${className}`}
      data-testid={testId}
      aria-label="Share RVA Students"
    >
      {copied ? (
        <>
          <Check size={16} /> Link Copied
        </>
      ) : (
        <>
          <Share2 size={16} /> {label}
        </>
      )}
    </button>
  );
};

export default ShareButton;
